var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Select } from "@irati/ui/src/FormItem";
import { orderBy } from "lodash";
import { injectIntl } from "@irati/utils/lang";
import OccasionsService from "@irati/recognition/services/Occasions";
import { OccasionIcon, RoundIconWrapper } from "./styled";
var OccasionsSelect = /** @class */ (function (_super) {
    __extends(OccasionsSelect, _super);
    function OccasionsSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            options: []
        };
        _this.handleChange = function (value) {
            var onChange = _this.props.onChange;
            if (value) {
                onChange(value);
            }
            else {
                onChange("");
            }
        };
        return _this;
    }
    OccasionsSelect.prototype.componentDidMount = function () {
        var _this = this;
        var formatMessage = this.props.formatMessage;
        OccasionsService.getAll().then(function (occasions) {
            var sortedOccasions = orderBy(occasions, "createdAt", "desc");
            var options = sortedOccasions
                .filter(function (occasion) { return !occasion.archived; })
                .map(function (occasion) {
                var name = occasion.default ? formatMessage({ id: occasion.name }) : occasion.name;
                var iconHref = occasion.default ? formatMessage({ id: occasion.icon.href }) : occasion.icon.href;
                var iconAlt = occasion.default ? formatMessage({ id: occasion.icon.alt }) : occasion.icon.alt;
                return {
                    label: (React.createElement(React.Fragment, null,
                        React.createElement(RoundIconWrapper, null,
                            React.createElement(OccasionIcon, { src: iconHref, alt: iconAlt })),
                        name)),
                    value: occasion.uuid
                };
            });
            _this.setState({ options: options });
        });
    };
    OccasionsSelect.prototype.render = function () {
        var options = this.state.options;
        var selectedOption = this.props.selectedOption;
        return (React.createElement(Select, { isSearchable: false, label: "platform.fields.occasions.select.label", value: selectedOption, onChange: this.handleChange, options: options }));
    };
    return OccasionsSelect;
}(Component));
export default injectIntl(OccasionsSelect);
